import React from "react";
import { Menu } from "semantic-ui-react";
import { PropTypes } from "prop-types";
import DocumentationMenuItems from "./documentation-menu-items";

const DocumentationMenu = ({ selectedItem, handleItemClick }) => {
  return (
    <Menu vertical tabular fluid style={{ paddingLeft: "1em" }}>
      <DocumentationMenuItems
        selectedItem={selectedItem}
        handleItemClick={handleItemClick}
      />
    </Menu>
  );
};

DocumentationMenu.propTypes = {
  selectedItem: PropTypes.string.isRequired,
  handleItemClick: PropTypes.func.isRequired,
};

export default DocumentationMenu;
